// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { globalBannerMessageStyles } from "@guestsupply/App/Widgets/GlobalBannerMessage/GlobalBannerMessage";
import Close from "@guestsupply/XDL/Icons/Close";
import { layoutContainer, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

globalBannerMessageStyles.wrapper = {
    css: css`
        position: relative;
        z-index: 1;
        ${({ backgroundColor }: any) =>
            backgroundColor &&
            css`
                background: ${backgroundColor};
            `}
    `,
};
globalBannerMessageStyles.messageWrapper = {
    css: css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 4px;
        padding-bottom: 8px;
        ${layoutContainer}
    `,
};
globalBannerMessageStyles.closeClickable = {
    css: css`
        position: absolute;
        right: 17px;
        top: 12px;

        &:focus {
            outline: none;
        }

        &:hover > ${IconWrapper} {
            opacity: 0.5;
        }
        ${xScreen("lte", "xs")} {
            right: 20px;
        }
    `,
};
globalBannerMessageStyles.closeIcon = {
    color: "common.ui1",
    src: Close,
    size: 11,
};
globalBannerMessageStyles.infoIcon = {
    color: "common.ui1",
    size: 15,
};
globalBannerMessageStyles.message = {
    color: "common.ui1",
    variant: "p",
    css: css`
        padding-right: 24px;
        margin-left: 8px;
        margin-bottom: 0;
        text-align: left;
        & > ${TypographyStyle} {
            font-size: inherit;
            color: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};
